import { render, staticRenderFns } from "./MarketApproveSettingAreaAcc.vue?vue&type=template&id=c996a680"
import script from "./MarketApproveSettingAreaAcc.vue?vue&type=script&lang=js"
export * from "./MarketApproveSettingAreaAcc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports